import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "waterQualityParameter";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    wQParameterList: {
      list: [],
      total: 0
    }
  },
  actions: {
    //查询-
    async getWQParameterData({ commit }, payload) {
      let result = await api.get(
        `/api/WaterQualityParameter?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setwQParameterList", result.data);
      }
      return result;
    },
    //删除数据
    async delWQParameter(a, payload) {
      let result = await api.delete(`/api/WaterQualityParameter/` + payload);
      return result;
    },
    //添加
    async addWQParameter(a, payload) {
      let result = await api.post("/api/WaterQualityParameter", payload);
      return result;
    },

    //编辑---获取单行数据
    async getEditWQParameter(a, payload) {
      let result = await api.get(`/api/WaterQualityParameter/` + payload);
      return result;
    },
    //修改
    async updateWQParameter(a, payload) {
      let result = await api.put(`/api/WaterQualityParameter`, payload);
      return result;
    },
    //获取参数曲线数据
    //查询-
    async getLineData(a, payload) {
      let result = await api.get(
        `/api/WaterQualityParameter/Graph?${queryString.stringify(payload)}`
      );
      return result;
    }
  },
  mutations: {
    setwQParameterList(state, payload) {
      state.wQParameterList = payload;
    }
  },
  getters: {}
});

export default moduleName;
